import { useState, useEffect } from 'react'
import Img from 'react-image'

export function SidebarCars() {
  const [cars, setCars] = useState([])
  const [renderSidebarCars, setRenderSidebarCars] = useState(false)

  const loadCars = (options = {}) => {
    if (options.gaEvent) App.GAEvent('Post Page', 'Click Load Next', null, null)

    App.Request.get(
      `/blog/${App.State.postId}/${App.State.slug}/sidebar_cars.json`
    ).then((response) => setCars(response.data.cars))
  }

  const checkRender = () => {
    const postContentEl = document.querySelector('.post-content')
    const carMakeListEl = document.querySelector('.car-make-list')

    const postContentRect = postContentEl.getBoundingClientRect()
    const carMakeListRect = carMakeListEl.getBoundingClientRect() ?? {
      height: 0,
    }

    setRenderSidebarCars(postContentRect.height >= carMakeListRect.height + 780)
  }
  useEffect(() => loadCars(), [])

  useEffect(() => checkRender(), [cars])

  return (
    <>
      <ul className="list-unstyled sidebar-cars-list d-none d-lg-block">
        {renderSidebarCars && cars.length >= 3 && (
          <div>
            {cars.map((car) => (
              <li
                className="d-block my-2 border-bottom sidebar-car-item"
                key={`sidebar-car-${car.car_id}`}
              >
                <a href={car.car_path} className="card border-0 shadow">
                  <div className="card-header-img">
                    <Img
                      src={car.primary_image}
                      className="card-img-top sidebar-car-image"
                      alt={car.image_alt}
                      loading="lazy"
                      loader={
                        <img
                          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mN8+ertfwAJRQPBTZk8XgAAAABJRU5ErkJggg=="
                          width={260}
                          height={170}
                          loading="lazy"
                          alt={car.image_alt}
                        />
                      }
                    />
                    <div className="card-img-overlay text-white align-items-end d-flex">
                      <small>{car.details}</small>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="card-title text-black mb-0 text-truncate">
                      {car.title}
                    </div>
                  </div>
                </a>
              </li>
            ))}

            <button
              type="button"
              className="btn btn-sm btn-primary align-center w-100"
              onClick={() => loadCars({ gaEvent: true })}
            >
              {I18n.t('posts.load_next_cars')}
            </button>
          </div>
        )}
      </ul>
    </>
  )
}